export default __webpack_public_path__ + "static/agri-fce668c53462e8aab1eda8bb7a27db1b.png";